let locale = new URL(location.href).searchParams.get('lang');
if(locale) {
  localStorage.setItem('lang',locale)
} else if (localStorage.getItem('lang')) {
  locale = localStorage.getItem('lang')
} else {
  // legacy
  locale = navigator.language.includes('-') ? navigator.language.split('-')[0].toLowerCase() : navigator.language.toLowerCase();
  if (locale != 'pl') locale == 'en';
}

import '../css/index.css';
import './vChecker.js';
import store from './store.js';
import routes, { restrictedRoutes, allowedRoutes } from './routes.js';
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import timezone from 'dayjs/plugin/timezone'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import isBetween from 'dayjs/plugin/isBetween'
import { setTheme } from './helpers/theme-helper.js'
import { queryToObject, debounce } from './utils.js'
import('dayjs/locale/' + locale + '.js')
import config from '@config';
import Vuex from 'vuex';
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';

import * as Sentry from "@sentry/browser";
//import { BrowserTracing } from "@sentry/tracing";
if(config.type==='prod'){

  Sentry.init({
    dsn: "https://fe5f667bbd8b46a39288d78cf5f40aad@o1157913.ingest.sentry.io/6240719",
    //integrations: [new BrowserTracing()],
    tracesSampleRate: 1.0,
  });
}

window.dayjs = dayjs;
window.$$ = Dom7;

Vue.use(Vuex);
Vue.use(VueCompositionAPI);

Framework7.registerComponent(
  'user-menu',
  (props, { $h }) => {
    let orgMenu = '';
    if(props.org && app.device.desktop){
      orgMenu = $h`
        <a href="${location.origin}/o/${props.olink}/e/${props.eid}/" class="menu-dropdown-link menu-close external no-hover">
          ${_LC.__pageUser.editEvent}
        </a>
        <a href="${location.origin}/o/${localStorage.getItem('o')}/" class="menu-dropdown-link menu-close external no-hover">
          ${_LC.__pageUser.organizerZone}
        </a>
      `;
    } else if (props.org && !app.device.desktop) {
      orgMenu = $h`
        <a href="" class="menu-dropdown-link menu-close popup-open no-hover" data-popup=".no-mobile-access-popup">
          ${_LC.__pageUser.editEvent}
        </a>
        <a href="" class="menu-dropdown-link menu-close popup-open no-hover" data-popup=".no-mobile-access-popup">
          ${_LC.__pageUser.organizerZone}
        </a>
      `;
    }
    return () => $h`
    <div class="menu-item menu-item-dropdown">
      <div class="avatar-arrow">
        ${props.profile_picture_url!='' ? $h`
          <img class="avatar-user" src="${props.profile_picture_url}" alt="" />
        ` : $h`
          <img class="avatar-user" src="./assets/img/profile-logo.png" alt="" />
        `}
        <img class="arr-org" src="./assets/icons/black-arrow.svg" alt="" />
      </div>
      <div class="menu-dropdown menu-dropdown-right">
        <div class="menu-dropdown-content user-navbar tw-shadow-lg">
          <p class="text-dark">
            ${props.user_name}
          </p>
          ${orgMenu}
          <a href="${config.lpUri}/events" class="menu-dropdown-link menu-close external no-hover">
            ${_LC.__pageUser.userZone}
          </a>
          <a href="#" class="menu-dropdown-link menu-close no-hover" @click="${logOut}">
            ${_LC.__pageUser.logout}
          </a >
        </div>
      </div>
    </div>
    `
  }
)
Framework7.registerComponent(
  'org-menu',
  (props, { $h }) => {
    return () => $h`
    <div class="menu-item menu-item-dropdown">
      <div class="avatar-arrow">
        ${props.logo_url=='' ? $h`
          <img class="avatar-user" src="./assets/img/organizer-logo.png" alt="" />
        ` : $h`
          <img class="avatar-user fit-contain" src="${props.logo_url}" alt="" />
        `}
        <img class="arr-org" src="./assets/icons/black-arrow.svg" alt="" />
      </div>
      <div class="menu-dropdown menu-dropdown-right">
        <div class="menu-dropdown-content user-navbar tw-shadow-lg">
          <p class="text-dark">${props.name}</p>
          <a href="/popup-select-organizer/" class="menu-dropdown-link menu-close no-hover">
            ${_LC.__organizer_dashboard.changeOrAddAnOrganizer}
          </a>
          <a href="/o/${props.link}/edit-profile/" class="menu-dropdown-link menu-close no-hover">
            ${_LC.__organizer_dashboard.organizatorProfile}
          </a>
          <a href="${config.lpUri}/events" class="menu-dropdown-link menu-close external no-hover" target="_self">
            ${_LC.__organizer_dashboard.userZone}
          </a>
          <a href="#" class="menu-dropdown-link menu-close no-hover" @click="${logOut}">
            ${_LC.__pageUser.logout}
          </a>
        </div>
      </div>
    </div>
    `
  }
)
window.app = new Framework7({
  name: 'Veventy',
  theme: 'aurora',
  el: '#app',
  version: config.version,
  type: config.type,
  view: {
    browserHistory: true,
    browserHistorySeparator: "",
    passRouteParamsToRequest: true,
    routesBeforeEnter: function({to, resolve, reject, router}){
      updateDayJsParams();

      if (to.path[to.path.length - 1] !== '/') {
        location.href = `${to.path.replace(/\/$/, '')}/${location.search}`;

        return reject();
      }

      if (`${to.path.replace(/\/$/, '')}/` === '/') {
        location.href = `${config.lpUri}/events`;

        return reject();
      }

      resolve();
    },
    preloadPreviousPage: false
  },
  popover: {
    backdrop: false,
  },
  dialog: {
    title: ' ',
  },
  popup: {
    swipeToClose: 'to-bottom',
    swipeHandler: '.popup h2'
  },
  store: window.store = store(),
  routes: window.routes = routes(),
});

function toggleAppBar() {
    let lastScrollTop = 0;

    window.addEventListener('scroll', () => {
      const st = window.scrollY;

      if (st > lastScrollTop) {
        if (st > 50) {
          $$('.appbar').addClass('hide');
          app.emit('appbar-hide');
        }
      } else {
        $$('.appbar').removeClass('hide');
        app.emit('appbar-show');
      }

      lastScrollTop = st <= 0 ? 0 : st;
    });
}

toggleAppBar();

function updateDayJsParams() {
  dayjs.locale(locale);
  dayjs.extend(utc);
  dayjs.extend(relativeTime);
  dayjs.extend(customParseFormat);
  dayjs.extend(timezone);
  dayjs.extend(advancedFormat);
  dayjs.extend(isBetween);
  dayjs.extend(duration);
}

window._LC = {};
window.defaultPath = window.location.pathname;
window.defaultRoute = defaultPath.split('/')[1];

// app init methods
window.getUserData = () => {
  return new Promise((resolve,reject) => {
    app.preloader.show()
    let waiting = true;
     app.request.get(app.store.getters.api.value + 'healthcheck')
     .then(()=>{
       waiting = false;
       continueGetUserData().then(()=>resolve()).catch(()=>reject())
     }).finally(()=>app.preloader.hide())
     setTimeout(() => {
       if(waiting)continueGetUserData().then(()=>resolve()).catch(()=>reject())
     }, 5000);
  })
}

function continueGetUserData () {
  return new Promise((resolve,reject) => {
    app.preloader.show()
    app.request.json(app.store.getters.api.value + 'user/me')
    .then( res => {
      res.data.social = res.data.social || {};
      app.store.state._USER = res.data;
      resolve()
    }).catch( err => {
      if (config.type === 'prod') Sentry.captureException(err);
      if(err.status==401){
        localStorage.removeItem('lg');
        location.reload();
      } else if (err.status==500) {
        location.href = '/maintenance/';
      } else if (err.status==429){
        setTimeout(() => location.reload(), 600);
      }
      reject()
    }).finally(()=>app.preloader.hide())
  })

}

window.routeToUri = (uri=null) => {
  const routeUri = uri ? uri : defaultPath + window.location.search;
  if (app.views.main) {
    app.views.main.router.navigate(routeUri, { animate: true, transition: 'f7-fade' })
  }else{
    app.views.create('.view-main', {
      loadInitialPage: false,
      browserHistory: true,
      history: true,
      preloadPreviousPage: false,
      iosSwipeBack: false,
      auroraSwipeBack: false,
      on: {
        init: function(v) {
          app.preloader.hide()
          v.router.navigate(routeUri,{animate: true, transition: 'f7-fade'})
        }
      }
    })
  }
}

async function startApp() {
  const token = new URL(location.href).searchParams.get('token');
  const params = queryToObject(new URLSearchParams(location.search));

  delete params.token;

  if (token) {
    localStorage.setItem('lg', decodeURIComponent(token));

    const query = new URLSearchParams(params).toString();

    history.replaceState({}, document.title, `${location.pathname}${query ? `?${query}` : ''}`);
  }

  setTheme('#3E4EFF');

  if(app.params.type==='dev')console.info('%ccreate view', 'color: #44d0ff;');
  if(defaultRoute=='maintenance'){
    routeToUri();
    return;
  }
  if (localStorage.getItem("lg") === null) {
    if(app.params.type==='dev')console.info('%cnot authorized', 'color: #ff9090;');
    if(allowedRoutes.includes(defaultRoute)){
      if(app.params.type==='dev')console.info('free access');
      routeToUri();
      return;
    } else if (restrictedRoutes.includes(defaultRoute)) {
      location.href = `${config.lpUri}/auth/login-redirect?origin=app&redirect=${encodeURIComponent(location.href)}`;
      return;
    } else {
      if(app.params.type==='dev')console.info('public org or event?');
      routeToUri();
      return;
    }
  } else {
    if(app.params.type==='dev')console.info('%cauthorized', 'color: #44d0ff;');
    app.store.state._TOKEN = localStorage.getItem("lg");
    Framework7.request.setup({
      headers: {
        'Authorization': app.store.getters.token.value
      }
    });

    if(defaultRoute=='not-found'){routeToUri();return;}
    getUserData().then(() => {
      if(!app.store.getters.user.value.first_name) {
        location.href = `${config.lpUri}/profile-short`;
        return;
      }

      routeToUri();
    });
  }
}

function getLocale(locale) {
  return new Promise((resolve, reject) => {
    import(`/src/locales/${locale}.json`).then(l => {
      _LC = l;
      resolve()
    })
  })
}

// app init
if (app.params.type === 'dev') console.info('%cveventy app init', 'color: #44d0ff;');

getLocale(locale).then(()=>startApp());

// notifications
window.showNotification = (text, bg, cb=false, cl=true, timeout=5000) => {
  if(cl)cb=false;
  app.notification.create({
    title: text,
    closeButton: cb,
    closeOnClick: cl,
    cssClass: bg,
    closeTimeout: timeout
  }).open();
}
// functions
window.nl2br = function nl2br(str){
 if(str)return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
}
window.logOut = async function logOut(){
  localStorage.removeItem('lg');

  location.href = `${config.lpUri}/auth/logout`;
}
window.copyToClipboard = function copyToClipboard(txt) {
  navigator.clipboard.writeText(txt).then(function() {
    showNotification(_LC.global.copiedLink, "nSuccess",true,true, 2000);
  }, function(err) {
    console.error('Could not copy text: ', err);
  });
}
window.checksum = function checksum(number) {
  const weights = [1,3,5,7,9,1,3,5,7,9,1,3,5,7,9];
  const max = number.length - 1;
  let sum = 0;
  for (let i = 0; i < max; ++i) {
    const n = parseInt(number.charAt(i), 10);
    sum += n * (weights[i]);
  }
  const control = sum % 11;
  return control === 10 ? 0 : control;
}
window.createEventID = function createEventID(eID) {
  const withChecksum = parseInt(String(eID) + String(checksum(String(eID))))
  return withChecksum.toString(36)
}
window.uploadFileS3 = async function uploadFileS3(bucketUrl, key, policy, sig, file, filename) {
  return new Promise((resolve, reject) => {
    let policyObject = JSON.parse(atob(policy).toString("utf8"));
    let data = new FormData();
    const findPolicyObject = (key) => {
      for (let item of policyObject.conditions) {
        if (typeof item[key] !== "undefined")
          return item[key];
      }
    };
    data.append("Key", key);
    data.append("ACL", findPolicyObject("ACL"));
    data.append("X-AMZ-Credential", findPolicyObject("X-AMZ-Credential"));
    data.append("X-AMZ-Algorithm", findPolicyObject("X-AMZ-Algorithm"));
    data.append("X-AMZ-Date", findPolicyObject("X-AMZ-Date"));
    data.append("X-AMZ-Meta-RID", findPolicyObject("X-AMZ-Meta-RID"));
    data.append("Policy", policy);
    data.append("X-AMZ-Signature", sig);
      const fd = new FormData();
      fd.append('file',file,filename);
      data.append("File", file, filename);
      fetch(bucketUrl, { method: 'POST', body: data })
          .then(res => resolve(res))
          .catch(err =>reject(err));
  });
}

app.on('popoverOpen', (popover) => {
  if (!popover.el.classList.contains('text-editor-popover')) {
    popover.el.style.transform = `translateY(${window.scrollY}px)`;
  }
});

window.addEventListener('scroll', debounce(() => {
  app.emit('resize');
}, 100));

window.addEventListener('resize', debounce(() => {
  app.emit('resize');
}, 100));
